module.exports = __webpack_public_path__ + "img/barCircleChart.a1f897e9.svg";